import { render } from "./NewGastoPage.vue?vue&type=template&id=28f1da53"
import script from "./NewGastoPage.vue?vue&type=script&lang=js"
export * from "./NewGastoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__